import { render, staticRenderFns } from "./ShippingInstructionReview.vue?vue&type=template&id=61081470&scoped=true&"
import script from "./ShippingInstructionReview.vue?vue&type=script&lang=js&"
export * from "./ShippingInstructionReview.vue?vue&type=script&lang=js&"
import style0 from "./ShippingInstructionReview.vue?vue&type=style&index=0&id=61081470&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61081470",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61081470')) {
      api.createRecord('61081470', component.options)
    } else {
      api.reload('61081470', component.options)
    }
    module.hot.accept("./ShippingInstructionReview.vue?vue&type=template&id=61081470&scoped=true&", function () {
      api.rerender('61081470', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/shipping-instruction/ShippingInstructionReview.vue"
export default component.exports